import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo } from '@apexdesigner/schema-tools';

export const processDesignHistory = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    eventType: z
      .enum(['Deployed', 'Suspended', 'Resumed', 'Replaced'])
      .describe('What happened to the process design'),

    data: z
      .unknown()
      .nullable()
      .optional()
      .presentAs('json')
      .describe('Additional details about what changed'),

    timestamp: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('When this event occurred'),

    processDesignId: z.uuid().hidden().describe('Foreign key to ProcessDesign'),

    processDesign: belongsTo('ProcessDesign'),
  })
  .describe("Records each significant event in a process design's lifecycle")
  .as('ProcessDesignHistory');

export { processDesignHistory as processDesignHistorySchema };
